import IApplicationRequest from "./IApplicationRequest";
import ICustomer from "../customer/ICustomer";
import IOrder from "./IOrder";
import FinancingType from "@/module/main/dto/FinancingTypeEnum";
import IFinancingSettings from "./IFinancingSettings";
import IMerchantURLs from "../IMerchantURLs";

export default class ApplicationRequest implements IApplicationRequest {
    constructor(
        public order: IOrder,
        public type: FinancingType,
        public merchantUrls: IMerchantURLs,
        public customer?: ICustomer,
        public settingsInstallment?: IFinancingSettings,
        public settingsConsumerLoan?: IFinancingSettings,
        public settingsGoodsFinancing?: IFinancingSettings,
    ) {
    }
}
